<template>
  <el-dialog :visible="visible" title="还款计划" @close="close" width="80%">
  <!-- <div id="conditions"> -->
    <!-- <el-tabs type="border-card" style="margin-bottom: 20px">
      <el-tab-pane v-for="(val, key, index) in repayDetailsInfo" :key="index">
        <span slot="label"><i class="el-icon-date" />{{ key }}</span>
        <el-table :data="val" class="repay-details-info" style="width: 100%; margin-bottom: 15px" border>
          <el-table-column prop="period" label="期数" />
          <el-table-column prop="repaymentPlanTime" label="到期还款日" />
          <el-table-column prop="repaymentTotalAmount" label="待还款总金额" />
          <el-table-column prop="repaymentRealTime" label="实际还款日期" />
          <el-table-column prop="repaymentIncomeAmount" label="已入账金额" />
          <el-table-column prop="repaymentPrincipalAmount" label="应收本金" />
          <el-table-column prop="repaymentInterestAmount" label="应收利息" />
          <el-table-column prop="overdueFeeAmount" label="应收罚息" />
          <el-table-column prop="overdueManageFeeAmount" label="应收逾期管理费" />
        </el-table>
      </el-tab-pane>
    </el-tabs> -->

    <!-- <el-tabs type="border-card">
      <el-tab-pane>
        <span slot="label"><i class="el-icon-date" />扣款记录</span>
        <PayLogInfo />
      </el-tab-pane>
      <el-tab-pane>
        <span slot="label"><i class="el-icon-date" />扣款成功记录</span>
        <PayLogInfo :success="true" />
      </el-tab-pane>
    </el-tabs> -->
    <el-table :data="repaymentData" v-loading="loading" class="repay-details-info" max-height="520px"
      style="width: 100%;" border>
      <el-table-column prop="biCyclyName" label="期次" />
      <el-table-column prop="bbillDate" label="账单日" width="100" />
      <el-table-column prop="biBillPrincipal" label="本金" />
      <el-table-column prop="biBillLoan" label="利息" />
      <el-table-column prop="xyBillCharge" label="服务费" />
      <el-table-column prop="biBillMerchantRenal" label="商户垫付" />
      <el-table-column prop="billtotalAmount" label="本期账单总额" width="110" />
      <el-table-column prop="overdueDays" label="逾期天数" />
      <el-table-column prop="biBillPenalty" label="罚息" />
      <el-table-column prop="xyPenyAmot" label="违约金" />
      <el-table-column prop="totalbiBillPenalty" label="总罚息" />
      <el-table-column prop="totalAmount" label="总金额" />
      <el-table-column prop="biBillPayFee" label="已还金额" />
      <el-table-column prop="biBillOweFee" label="欠费金额" />
      <el-table-column prop="biPayStatus" label="结清状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.biPayStatus == 0" type="danger">未结清</el-tag>
          <el-tag v-if="scope.row.biPayStatus == 1" type="success">已结清</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="withhold" label="还款状态">

        <template slot-scope="scope">
          <span v-if="scope.row.withhold == 1">待扣款</span>
          <span v-if="scope.row.withhold == 2">扣款处理中</span>
          <span v-if="scope.row.withhold == 3">待渠道回调</span>
          <span v-if="scope.row.withhold == 4">待冲账</span>
          <span v-if="scope.row.withhold == 5">冲账处理中</span>
          <span v-if="scope.row.withhold == 6">还款成功</span>
          <span v-if="scope.row.withhold == 7">扣款失败</span>
          <span v-if="scope.row.withhold == 8">冲账失败</span>
        </template>
      </el-table-column>
      <el-table-column prop="isPaydeducted" label="还款描述" width="200" />
      <el-table-column label="账单标识" width="250">

        <template slot-scope="scope">
          <el-tag style="margin-left: 5px;"  v-if="scope.row.isCompensation == 1">已代偿</el-tag>
          <el-tag style="margin-left: 5px;"  v-if="scope.row.isBuyBack == 1" type="success">已回购</el-tag>
          <el-tag style="margin-left: 5px;"  v-if="scope.row.fdBuyBackStatus == 1"
            type="warning">代偿挂起</el-tag>
          <el-tag style="margin-left: 5px;"  v-if="scope.row.isTransfer == 0" type="danger">已转让</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 20px;text-align: left;">
      <el-pagination :total="total" :page-sizes="[15, 50]" :page-size="queryParms.pageSize"
        layout="total, sizes, prev, pager, next" @size-change="sizeChange" @current-change="changePage" />
    </div>
    <!-- ------------------------------------------ -->
    <div style="margin: 20px 0 10px;font-size: 16px;font-weight: 700;border-top: 1px solid #eaeefb;padding-top: 20px;">
      还款记录
    </div>
    <el-table :data="repaymentData2" v-loading="loading2" class="repay-details-info" max-height="500px"
      style="width: 100%;" border>
      <el-table-column prop="operationTime" label="扣款时间" />
      <el-table-column prop="remarks" label="扣款状态" />
      <el-table-column prop="repaymentAmount" label="扣款" />
      <el-table-column prop="bankCard" label="扣款卡" />
      <el-table-column prop="repaymentWayValue" label="扣款入口" />
      <el-table-column prop="repaymentRecordLabel" label="标签" />
      <el-table-column prop="updateUser" label="操作人" />
    </el-table>
    <div style="margin: 20px 0 40px;text-align: left;">
      <el-pagination :total="total2" :page-sizes="[10, 15, 20, 50]" :page-size="queryParms2.pageSize"
        layout="total, sizes, prev, pager, next" @size-change="sizeChange2" @current-change="changePage2" />
    </div>
  <!-- </div> -->
  </el-dialog>
</template>

<script>
// import * as taskApi from '../../api/task.js'
// import PayLogInfo from './components/payLogsInfo'
import { queryrepayPlanList, repaymentRecordList } from '@/api/task'

// const moment = require('moment')

export default {
  name: 'conditions',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    taskId: {
      type: [Number, String],
      required: true
    }
  },
  components: {
    // PayLogInfo
  },
  data() {
    return {
      repayDetailsInfo: {},
      repayDetailsPage: 0,
      repaymentData: [],
      queryParms: {
        currentPage: 1,
        pageSize: 15,
        taskId: ''
      },
      // 总条数
      total: 0,
      loading: true,
      repaymentData2: [],
      queryParms2: {
        currentPage: 1,
        pageSize: 10,
        taskId: ''
      },
      // 总条数
      total2: 0,
      loading2: true
    }
  },
  computed: {
    id() {
      return this.$route.params.taskId
    }
  },
  created() {
    // this.loadRepayDetails()
    this.repayPlanData()
    this.repaymentRecordData()
  },
  methods: {
    close() {
      this.$emit('hide')
    },
    // loadRepayDetails() {
    // const params = {
    //   taskId: this.id
    // }
    // taskApi.fetchRepayPlan(params).then(res => {
    //   for (let item in res.data) {
    //     res.data[item].map(subItem => {
    //       if (subItem.repaymentPlanTime) subItem.repaymentPlanTime = moment(subItem.repaymentPlanTime).format('YYYY-MM-DD')
    //       if (subItem.repaymentRealTime) subItem.repaymentRealTime = moment(subItem.repaymentRealTime).format('YYYY-MM-DD')
    //     })
    //   }
    //   this.repayDetailsInfo = res.data
    // })
    // },
    repayPlanData() {
      this.loading = true
      this.queryParms.taskId = this.id
      queryrepayPlanList(this.queryParms).then((res) => {
        this.repaymentData = res.data.records
        this.total = res.data.total
        this.loading = false
      })
    },
    sizeChange(size) {
      this.queryParms.pageSize = size
      this.repayPlanData()
    },
    changePage(currentPage) {
      this.queryParms.currentPage = currentPage
      this.repayPlanData()
    },
    repaymentRecordData() {
      this.loading2 = true
      this.queryParms2.taskId = this.id
      repaymentRecordList(this.queryParms2).then((res) => {
        this.repaymentData2 = res.data.records
        this.total2 = res.data.total
        this.loading2 = false
      })
    },
    sizeChange2(size) {
      this.queryParms2.pageSize = size
      this.repaymentRecordData()
    },
    changePage2(currentPage) {
      this.queryParms2.currentPage = currentPage
      this.repaymentRecordData()
    }
  }
}
</script>
